import React from 'react';
import cn from 'classnames';
import styles from './styles.css';

const AgendaListItemIcon = ({ event }) => {
  let status = 'default';
  if (event.resource.type === 'LOT_TRANSFER') {
    status = event.resource.lotTransfer.type.toLowerCase();
  } else if (event.resource.type === 'SCHEDULED_LOT') {
    status = 'scheduled_lot';
  }
  const style = styles[status];
  return <span className={cn(styles.container, style, 'mr2 dib br-100')} />;
};

export default AgendaListItemIcon;



// WEBPACK FOOTER //
// ./src/components/agendaListItemIcon/agendaListItemIcon.jsx